<template>
  <v-container>
    <v-row>
      <v-dialog v-model="showPreviewDialog" max-width="500">
        <v-card>
          <v-img
            v-if="pictureField(dictionary)"
            :src="currentUrl"
            :lazy-src="currentUrl"
          />
          <pdfvuer
            v-if="pdfField(dictionary)"
            :src="currentUrl"
            :scale="'page-width'"
          />
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col :cols="fieldPreview(dictionary, currentUrl) ? 11 : null">
        <v-file-input
          v-model="file"
          v-show="!hiddenField(access)"
          :prepend-icon="prependIcon()"
          :id="id"
          :label="customLabel()"
          :required="requiredField(access)"
          :filled="readonlyField(access)"
          :rules="rules"
          :accept="pattern"
          :clearable="false"
          :disabled="readonlyField(access) || showPreviewDialog"
          @change="handleChange"
        >
          <template
            v-if="fieldPreview(dictionary, currentUrl)"
            v-slot:selection="{ text }"
          >
            <v-container :key="currentUrl">
              <v-row>
                <v-col>
                  <v-card
                    class="mx-auto"
                    max-height="150"
                    max-width="150"
                    flat
                    outlined
                  >
                    <v-img
                      v-if="pictureField(dictionary) && !fileLoading"
                      :dummy="text"
                      :src="currentUrl"
                      :lazy-src="currentUrl"
                      contain
                    />
                    <pdfvuer
                      class="custom-preview-small"
                      v-if="pdfField(dictionary) && !fileLoading"
                      :scale="'page-width'"
                      :src="currentUrl"
                      max-height="150"
                      max-width="150"
                    />
                  <v-app-bar flat :color="appbarColor()" height="40">
                        <v-spacer></v-spacer>
                        <v-btn
                          color="white"
                          icon
                          small
                          v-for="action in actions"
                          :key="action.title"
                          @click="action.function"
                          v-show="action.show()"
                        >
                          <v-icon>{{ action.icon }}</v-icon>
                        </v-btn>
                      </v-app-bar>
                  </v-card>
                  <br />
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-file-input>
      </v-col>
      <v-col v-if="fieldPreview(dictionary, currentUrl)" cols="1">
        <v-btn
          color="back"
          icon
          small
          v-for="action in actions"
          :key="action.title"
          @click="action.function"
          v-show="action.show()"
        >
          <v-icon>{{ action.icon }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PSD from "psd.js/dist/psd.min.js";
import pdfvuer from "pdfvuer";
export default {
  name: "FileField",
  props: [
    "label",
    "value",
    "access",
    "dataType",
    "pattern",
    "id",
    "name",
    "rules",
    "upload",
    "generalExApplicationEx",
    "dictionary",
    "uploaded",
    "selected",
    "progress",
    "loading",
    "url",
    "screen",
  ],
  components: {
    pdfvuer,
  },
  data() {
    return {
      defaultValue: this.value,
      currentValue: this.value,
      defaultUrl: this.url,
      currentUrl: this.url,
      file: this.emptyString(this.value) ? null : {},
      buffer: null,
      showPreviewDialog: false,
      fileLoading: false,
      actions: [
        {
          title: "Preview",
          icon: "mdi-magnify",
          function: () => {
            this.doPreview();
          },
          show: () => {
            return this.fieldPreview(this.dictionary, true);
          },
        },
        /*
        {
          title: "Download",
          icon: "mdi-download",
          function: () => {
            this.doDownload();
          },
          show: () => {
            return this.showDownload();
          },
        },
        */
      ],
      loadedHere: false,
      disabled: false
    };
  },
  methods: {
    handlePsd(fileName) {
      if (this.isFilePsd(fileName)) {
        this.fileLoading = true;
        PSD.fromURL(this.currentUrl)
          .then((psd) => {
            this.fileLoading = false;
            this.currentUrl = psd.image.toPng().attributes["src"].value;
          })
          .catch((error) => {
            this.fileLoading = false;
            console.log(error);
          });
      }
    },
    handleChange() {
      this.$emit("set-loading", true);
      this.getBase64(this.file)
        .then((binary) => {
          this.loadedHere = true;
          this.currentUrl = URL.createObjectURL(this.file);
          this.handlePsd(this.file.name);
          this.buffer = binary;
          const data = {
            value: this.currentValue,
            id: this.id,
            file: this.file,
            selected: true,
            progress: 0,
            uploaded: false,
            buffer: this.buffer,
          };
          this.$emit("field-change", data);
          this.$emit("set-loading", false);
        })
        .catch(() => {
          this.$emit("set-loading", false);
        });
    },
    doPreview() {
      this.showPreviewDialog = !this.showPreviewDialog;
    },
    showDownload() {
      return this.notBlank(this.currentValue);
    },
    doDownload() {
      let url = this.currentValue;
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          const title = this.getFileNameNoUndefined(this.currentValue);
          link.href = url;
          link.setAttribute("download", title);
          document.body.appendChild(link);
          link.click();
        });
    },
    appbarColor() {
      return this.currentUrl ? "rgba(0, 0, 0, 0.5)" : "transparent";
    },
    customLabel() {
      return this.label;
    },
    colsFileLoad() {
      return this.pictureField(this.dictionary) ? "9" : "12";
    },
    colsPreview() {
      return this.pictureField(this.dictionary) ? "3" : "0";
    },
    prependIcon() {
      return this.pictureField(this.dictionary)
        ? "mdi-camera"
        : this.pdfField(this.dictionary)
        ? "mdi-file-pdf-box"
        : "mdi-folder-open";
    },
  },
  mounted() {
    this.handlePsd(this.currentUrl);
  },
};
</script>

<style scoped>
.custom-preview-small {
  max-height: 150px;
  max-width: 150px;
}
</style>